module.exports = __webpack_public_path__ + "static/media/IMG_1317.64dfaf0a.JPG";